import { SurveySubmittedTypes } from "../SurveySubmittedTypes";
import images from "../../ImageVariables";
import "../SCSS/mobileStyles.css";
function MobileSurveySubmittedPage({
  handleViewSubbmission,
}: SurveySubmittedTypes) {
  return (
    <div className="mobile-survey-submitted-page-main-container">
      <div className="mobile-survey-submitted-page-main-wrapper">
        <div className="mobile-survey-submitted-page-svg-cover">
          <div className="mobile-survey-submitted-page-svg-wrapper">
            <img
              className="mobile-survey-submitted-page-img"
              src={images.surveySubmitted}
              alt="survey-submitted-page"
            />
          </div>
        </div>
        <div className="mobile-survey-submitted-page-header-description-cover">
          <div className="mobile-survey-submitted-page-header-text-wrapper">
            <div className="mobile-survey-submitted-page-description-text-cover">
              <p className="mobile-survey-submitted-page-description">
                Your assessment has already been submitted
              </p>
            </div>
            <div className="mobile-survey-submitted-page-header-text-cover">
              <h3 className="mobile-survey-submitted-page-header">Thank you</h3>
            </div>
          </div>
          <div className="mobile-view-submission-cover">
            <button
              onClick={() => handleViewSubbmission()}
              className="mobile-view-submission-btn"
            >
              View Submission
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
export default MobileSurveySubmittedPage;
